import React from 'react'

import { PasswordInput } from './UI/PasswordInput'
import { PasswordStrengthIndicator } from './UI/PasswordStrengthIndicator'
import { LoadingSpinner } from './UI/Icons'
import { Input } from '../../Login/Components/UI/Input'

export const CredentialsStep = ({ 
  formData, 
  errors, 
  touched, 
  onChange, 
  onBlur, 
  onSubmit,
  onBack,
  loading,
  showPassword,
  showPassword2,
  onTogglePassword,
  onTogglePassword2
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label htmlFor="username" className="block text-xs font-medium text-gray-700 mb-1">
          Username
        </label>
        <Input
          id="username"
          name="username"
          type="text"
          value={formData.username}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Choose a username"
          error={errors.username}
          touched={touched.username}
        />
        {errors.username && touched.username && (
          <p className="mt-1 text-xs text-red-600">{errors.username}</p>
        )}
      </div>

      <div>
        <label htmlFor="phone_number" className="block text-xs font-medium text-gray-700 mb-1">
          Phone Number
        </label>
        <Input
          id="phone_number"
          name="phone_number"
          type="tel"
          value={formData.phone_number}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Your phone number"
          error={errors.phone_number}
          touched={touched.phone_number}
        />
        {errors.phone_number && touched.phone_number && (
          <p className="mt-1 text-xs text-red-600">{errors.phone_number}</p>
        )}
      </div>

      <div>
        <label htmlFor="password" className="block text-xs font-medium text-gray-700 mb-1">
          Password
        </label>
        <PasswordInput
          id="password"
          name="password"
          value={formData.password}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Create a password"
          showPassword={showPassword}
          onTogglePassword={onTogglePassword}
          error={errors.password}
          touched={touched.password}
        />
        <PasswordStrengthIndicator password={formData.password} />
        {errors.password && touched.password && (
          <p className="mt-1 text-xs text-red-600">{errors.password}</p>
        )}
      </div>

      <div>
        <label htmlFor="password2" className="block text-xs font-medium text-gray-700 mb-1">
          Confirm Password
        </label>
        <PasswordInput
          id="password2"
          name="password2"
          value={formData.password2}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Confirm your password"
          showPassword={showPassword2}
          onTogglePassword={onTogglePassword2}
          error={errors.password2}
          touched={touched.password2}
        />
        {errors.password2 && touched.password2 && (
          <p className="mt-1 text-xs text-red-600">{errors.password2}</p>
        )}
      </div>

      <div>
        <label htmlFor="referral_code" className="block text-xs font-medium text-gray-700 mb-1">
          Referral Code (Optional)
        </label>
        <Input
          id="referral_code"
          name="referral_code"
          type="text"
          value={formData.referral_code}
          onChange={onChange}
          placeholder="Enter referral code if you have one"
        />
      </div>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={onBack}
          className="w-1/3 bg-gray-200 text-gray-800 py-2.5 px-3 rounded-md font-medium hover:bg-gray-300 transition duration-200 text-sm"
        >
          Back
        </button>
        <button
          type="submit"
          disabled={loading}
          className={`w-2/3 bg-teal-500 text-white py-2.5 px-3 rounded-md font-medium hover:bg-teal-600 transition duration-200 text-sm ${
            loading ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <LoadingSpinner />
              Creating Account...
            </span>
          ) : (
            "Create Account"
          )}
        </button>
      </div>
    </form>
  )
}